import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------fatch-community-listing--------------------------
export const getCommunityApi = async (data) => {
  const endPoint =
    `/community/list` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const getReferPostApi = async (data) => {
  const endPoint =
    `/community/refer_post` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// ---------------------add-category---------------------------
export const AddCommunityApi = async (data) => {
  const endPoint = `/community/add`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};
// --------------------single-view-details-community---------------------------
export const getCommunityDetailsApi = async (id) => {
  const endPoint = `/community/view/${id}`;
  return await axios.get(endPoint, setJwtToken());
};
// ---------------------update-product---------------------------
export const updateCommunityApi = async (id, data) => {
  const endPoint = `/community/update/${id}`;
  return await axios.put(endPoint, data, setMultiPartHeader());
};
// ---------------------change-status-community---------------------------
export const changeCommunityStatusApi = async (data) => {
  const endPoint = `/community/change_status`;
  return await axios.put(endPoint, data, setJwtToken());
};

export const sendMailReferPostApi = async (data) => {
  const endPoint = `/community/refer_mail_status`;
  return await axios.put(endPoint, data, setJwtToken());
};
// --------------------delete-product---------------------------
export const deleteCommunityApi = async (id) => {
  const endPoint = `/community/delete/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
//------------------get-post(share)-list-----------------------------
export const getPostListApi = async (id, data) => {
  const endPoint =
    `/community/post/${id}` + `?` + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
//------------------delete-post(share)-----------------------------
export const deletePostApi = async (id) => {
  const endPoint = `/community/post_delete/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
//------------------get-meetups-list-----------------------------
export const getMeetupsListApi = async (id, data) => {
  const endPoint =
    `/community/meetup/${id}` +
    `?` +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
//------------------get-member-list-----------------------------
export const getMemberListApi = async (id, data) => {
  const endPoint =
    `/community/member/${id}` +
    `?` +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
//------------------delete-member-list-----------------------------
export const deleteMemberAPi = async (data) => {
  const endPoint =
    `/community/member_remove` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
//------------------change-moderator----------------------------
export const changeModeratorApi = async (data) => {
  const endPoint = `/community/change_moderator`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};

//---------------community-Details---post-details----------------------------
export const postDetailsApi = async (id) => {
  const endPoint =
    `community/post_detail/` + `?` + new URLSearchParams({ ...id }).toString();
  return await axios.get(endPoint, setJwtToken());
};
